import { Component, OnInit, ViewChild } from '@angular/core';
import { TreeService } from '@service/tree.service';
import { TreeNode } from 'primeng/api';
import { MessagesService } from '@core/_services/messages.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { TreeSearchRequestComponent } from '@documalis/treesearchrequest';
import { CheckTools } from '@service/check.tools';
import {
    encodeUtf8,
    getGroupListData,
    getProfilListData,
    getArray,
    truncString,
    sortBy,
    convertStringToBoolean,
    returnEmpty,
} from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { RequestTools } from '@service/request.tools';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'page-access-right',
    templateUrl: './page-access-right.component.html',
    styleUrls: ['./page-access-right.component.scss'],
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
            z-index: 1;
        }
        .layout-news-active :host ::ng-deep .p-datatable tr > th {
            top: 7rem;
        }
    `]
})
export class PageAccessRightComponent implements OnInit {
    public error = false;
    public treeIndex;
    public resultTree;
    public groupList = [];
    public profilList = [];
    public selectedFile: TreeNode; //[] = [];
    public updatePath = '';
    public isDesktop: boolean = false;
    public errorMessage = '';
    public errorLoaderDialog = false;
    public checkFilter = false;
    public accessRight = [];
    public recurs: boolean = true;
    private baseRoot = [];
    private tree: any;
    private key: number;
    private filteredList = [];
    private rootPath: any = {};
    public blockedTree: boolean = false;

    @ViewChild('treerequest') public treeRequest: TreeSearchRequestComponent;

    constructor(
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private treeService: TreeService,
        private checkTools: CheckTools,
        private commonService: CommonService,
        private main: LayoutService,
        private requestTools: RequestTools,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
    }

    ngOnInit() {
        this.findAll();
        this.commonService.checkReset();
        this.updatePath = '';
    }

    private async findAll() {
        let wRes: any = {};
        this.baseRoot = [];
        try {
            wRes.data = await lastValueFrom(this.requestTools.getAccessRight());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.baseRoot = wRes.data.getAccessRight.BaseRootList.BaseRoot;
        this.resultTree = wRes.data.getRootPath.base.result;
        
        this.profilList.push({label: 'Groupe'});
        this.profilList.push({label: 'Full'});
        this.profilList = this.profilList.concat(getProfilListData(wRes.data.getProfilList.ProfilGedList));

        this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
        
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        this.initAccessRight();
        this.prepareList();
    }

    private prepareList() {
        let wRightList = [];
        let wRootList = [];
        let steps;
        this.key = 0;
        this.filteredList = [];
        for (let i = 0; i < this.baseRoot.length; i++) {
            wRootList = getArray(this.baseRoot[i].RL.R);
            if (wRootList.length !== 0) {
                wRightList = [];
                for (let j = 0; j < wRootList.length; j++) {
                    wRightList.push({
                        B: wRootList[j].B,
                        G: wRootList[j].G,
                        I: wRootList[j].I,
                        P: wRootList[j].P,
                        PL: wRootList[j].PL,
                        R: wRootList[j].R,
                    })
                }                
                wRightList = sortBy('P', wRightList, {order:1});
                this.tree = {};
                this.key++;
                for (let x=0; x < wRightList.length; x++) {
                    steps =wRightList[x].P.split('\\');
                    if (steps[0].toUpperCase() !== wRightList[x].B.toUpperCase()) {
                        steps[0] = wRightList[x].B;
                    }
                    this.fillTree(steps);
                }
                this.filteredList.push(this.tree);
            }
        }
    }

    private fillTree(steps) {
        var current = null;
        var existing = null;
        for (let y = 0; y < steps.length; y++) {
           if (y===0) {
              if (!this.tree.children||typeof this.tree.children == 'undefined'){
                 this.tree = { label: steps[y], key: this.key.toString(), loaded: true, children: [] };
              }
              current = this.tree.children;
           } else {
              existing = null;
              for (let i=0; i < current.length; i++) {
                 if (current[i].label === steps[y]) {
                    existing = current[i];
                    break;
                 }
              }
              if (existing) {
                 current = existing.children;
              } else {
                this.key++;
                 current.push({ label: steps[y], key: this.key.toString(), loaded: true, children: [] });
                 current = current[current.length - 1].children;
              }
           }
        }
     }

    private initAccessRight() {
        let wProfil = [];
        this.accessRight = [];
        this.groupList.forEach((group) => {
            wProfil = [];
            this.profilList.forEach((profil) => {
                wProfil.push({
                    label: profil.label,
                    activ: false,
                    id: '',
                })
            });
            this.accessRight.push({
                grpName: group.value,
                grpLabel: group.label,
                access : wProfil
            });            
        });
    }

    public onChangeCkFilter($event) {
        this.updatePath = '';
        this.initAccessRight();
        this.selectedFile = null;
        this.setTreeIndex($event.checked);
    }

    private setTreeIndex(aValue) {
        if (aValue === false) {
            this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        } else {
            // Répertoires avec droits
            this.treeIndex = this.treeService.updateTreeSearch(JSON.stringify({data: this.filteredList}));
        }    
    }

    public updateRightClick() {
        if (this.updatePath === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Dir_Sel'));
            return;
        }
        this.prepareUpdate(this.recurs, this.rootPath);        
    }

    private async prepareUpdate(aRecurs, aRootPath) {
        let wPrepar: any;
        let wRes: any;
        let wMess: string;
        let wRequest: {};
        wPrepar = this.prepareUpdateList(aRecurs, aRootPath);

        // console.log('prepareUpdate wCreateList', wPrepar.createList);
        // console.log('prepareUpdate wUpdateList', wPrepar.updateList);
        for (let i=0; i < wPrepar.updateList.length; i++) {
            wRequest = this.formatRequest(wPrepar.updateList[i], true);
            wRes = await this.requestTools.execUrlAction('setright', wRequest);
            this.checkTools.checkError(wRes);
            if (this.checkTools.getRes() === false) {
                wMess = returnEmpty(wRes.Message);
                if (wMess !== '') {
                    this.checkTools.check.msg = wMess;
                }
                this._messageService.addErrorMsg(this.checkTools.getMsg(),this.translate.instant('Update_KO'));
                return;
            }
        };
        for (let i=0; i < wPrepar.createList.length; i++) {
            wRequest = this.formatRequest(wPrepar.createList[i], false);
            wRes = await this.requestTools.execUrlAction('setright', wRequest);
            this.checkTools.checkError(wRes);
            if (this.checkTools.getRes() === false) {
                wMess = returnEmpty(wRes.Message);
                if (wMess !== '') {
                    this.checkTools.check.msg = wMess;
                }
                this._messageService.addErrorMsg(this.checkTools.getMsg(),this.translate.instant('Update_KO'));
                return;
            }
        };
        this.baseRoot = [];
        wRes = await this.requestTools.getAsyncAccessRightUpdate();
        this.baseRoot = wRes.data.getAccessRight.BaseRootList.BaseRoot;
        this.checkTools.checkError(wRes.data.getAccessRight);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return;
        }

        this.resultTree = wRes.data.getRootPath.base.result;              
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        this.initAccessRight();
        this.prepareList();

        this.updatePath = '';
        this.selectedFile = null;
        this.setTreeIndex(this.checkFilter);
        this._messageService.addSuccess(this.translate.instant('Update_OK'));
    }

    private formatRequest(aPrepar, aUpdate) {
        let wRequest: {};
        if (aUpdate === true) {
            wRequest = {                
                id: aPrepar.id,
                Recursive: aPrepar.recurs,
                ProfilList: aPrepar.profilList
            }            
        } else {
            wRequest = {
                BaseRoot: aPrepar.baseRoot,
				Group: aPrepar.grpName,
				Path: aPrepar.path,
				Recursive: aPrepar.recurs,
				ProfilList: aPrepar.profilList
            }
        }
        return {
            request: wRequest,
            aupdate: aUpdate
        };
    }

    private prepareUpdateList(aRecurs, aRootPath) {
        let wProfilList = '';
        let wCurrentId = '';
        let wCreateList = [];
        let wUpdateList = [];
        this.accessRight.forEach((item) => {
            wProfilList = '';
            wCurrentId = ''
            for (let i = 1; i < item.access.length; i++) {    
                // maj profilist
                if (item.access[i].activ === true) {
                    if (i === 1) {
                        wProfilList +=  '*,'
                    } else {
                        wProfilList += item.access[i].label + ','
                    }
                }
                if (item.access[i].id !== '') {
                    // maj 
                    wCurrentId = item.access[i].id
                }
            }
            wProfilList = truncString(wProfilList,1);
            if (wCurrentId === '') {
                if (wProfilList !== '') {
                    // Création
                    wCreateList.push({
                        baseRoot: aRootPath.root,
                        path: this.getPath(aRootPath),
                        grpName: item.grpName,
                        profilList: wProfilList,
                        recurs: aRecurs
                    });
                }
            } else {
                wUpdateList.push({
                    id: wCurrentId,
                    grpName: item.grpName,
                    profilList: wProfilList,
                    recurs: aRecurs
                });
            }
        });
        return {
            createList: wCreateList,
            updateList: wUpdateList
        }
    }

    private getPath(aRootPath) {
        if (aRootPath.path.trim() === '') {
            return aRootPath.basePath;
        } else {
            return aRootPath.basePath + '\\' + truncString(aRootPath.path,1);
        }
    }

    // Sélection d'un élément de l'arbo
    public nodeSelect(event) {
        this.rootPath = {};
        let wSearchPath = '';
        this.initAccessRight();
        wSearchPath = this.treeService.getPathClick(event.node, '');
        this.updatePath = wSearchPath.trim();
        wSearchPath = encodeUtf8(wSearchPath);
        // Récup du root/path sélectionné
        this.rootPath = this.treeService.getRootPath(wSearchPath);
        this.getRootList(this.rootPath.root.toUpperCase(), this.rootPath.path.toUpperCase());
    }

    public async nodeExpand(event) {
        let wRes;
        wRes = await this.treeService.nodeExpand(event, (callBack) => {
            this.blockedTree = callBack;
        });
    }

    // Maj des droits actifs
    private setActiv(aRight) {
        let wProfilList = [];
        wProfilList = this.getProfilList(aRight);
        for (let i = 0; i < this.accessRight.length; i++) {
            if (this.accessRight[i].grpName === aRight.G) {
                for (let j = 0; j < wProfilList.length; j++) {
                    for (let k = 0; k < this.accessRight[i].access.length; k++) {
                        if (this.accessRight[i].access[k].label === wProfilList[j]) {
                            this.accessRight[i].access[k].activ = true;
                            this.accessRight[i].access[k].id = aRight.I;
                            break;
                        }
                    }                    
                }
                break;
            }
        }
    }

    // Récup de la liste des profils associés à chaque groupe
    private getProfilList(aRight) {
        let wProfilList = [];
        wProfilList = aRight.PL.split(',');
        wProfilList = wProfilList.map(item => {
            if (item === '*') {
                item = 'Full';
            }
            return item;
        })
        return wProfilList;
    }

    // Recherche de la racine sélectionnée
    private getRootList(aRoot, aPath) {
        let wRootList = [];
        let wRootTest = '';
        for (let i = 0; i < this.baseRoot.length; i++) {
            if (this.baseRoot[i].Information.Name.toUpperCase() === aRoot) {
                this.rootPath.basePath = this.baseRoot[i].Information.Path;
                wRootTest = this.baseRoot[i].Information.Path.toUpperCase();
                wRootList = getArray(this.baseRoot[i].RL.R);
                break;
            }
        }
        if (wRootList.length !== 0) {
            this.getRight(wRootList, truncString(wRootTest + '\\' + aPath,1));
        }
    }

    // Recherche des chemins sélectionnés
    private getRight(aRootList, aPath) {
        this.recurs = true;
        for (let i = 0; i < aRootList.length; i++) {
            if (aRootList[i].P.toUpperCase() === aPath) {        
                this.recurs = convertStringToBoolean(aRootList[i].R);
                this.setActiv(aRootList[i]);
            }
        }
    }
}
